import { render, staticRenderFns } from "./LoginNew.vue?vue&type=template&id=52086436&"
import script from "./LoginNew.vue?vue&type=script&lang=js&"
export * from "./LoginNew.vue?vue&type=script&lang=js&"
import style0 from "./LoginNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports